export default "__VITE_ASSET__26f4a231__"